// extracted by mini-css-extract-plugin
export default {"overlay":"yx-z","bodyOpen":"zx-z","content":"Ax-z","header":"Bx-z","close":"Cx-z","closeNoHeading":"Dx-z"};